/** Injected at build time via Vite `define` (see vite.config.ts). */
declare const __APP_VERSION__: string
declare const __APP_BUILD__: string

export function appVersion(): string {
  return __APP_VERSION__
}

export function appBuild(): string {
  return __APP_BUILD__
}

/** Human-facing build label, e.g. `1.0.0 · a1b2c3d`. */
export function buildLabel(): string {
  return `${appVersion()} · ${appBuild()}`
}
